// extracted by mini-css-extract-plugin
export var bubble = "_3p-0";
export var container = "_3p-f";
export var contrastBorder = "_3p-g";
export var greyOut = "_3p-2";
export var initialsColor0 = "_3p-3";
export var initialsColor1 = "_3p-4";
export var initialsColor10 = "_3p-d";
export var initialsColor11 = "_3p-e";
export var initialsColor2 = "_3p-5";
export var initialsColor3 = "_3p-6";
export var initialsColor4 = "_3p-7";
export var initialsColor5 = "_3p-8";
export var initialsColor6 = "_3p-9";
export var initialsColor7 = "_3p-a";
export var initialsColor8 = "_3p-b";
export var initialsColor9 = "_3p-c";
export var initialsWrapper = "_3p-1";
export var large = "_3p-l";
export var medium = "_3p-k";
export var mediumSmall = "_3p-j";
export var mediumSmallMedium = "_3p-o";
export var micro = "_3p-h";
export var small = "_3p-i";
export var tiny = "_3p-n";
export var xTiny = "_3p-m";